<template>
  <v-card flat height="100vh" class="pl-2" style="overflow-y: auto;">
    <v-row class="mt-1 ">
      <v-col cols="6">
        <span
          style="font-weight: 500;
    font-size: 20px;"
          >Form Builder</span
        >
      </v-col>
      <v-col cols="6" style="display: flex;justify-content: space-between;">
        <div style="min-width: 68%;">
          <CustomAutoComplete
            v-if="sampleData && sampleData.length > 0 && !allowEdit"
            density="compact"
            placeholder="Select sample"
            :items="sampleData"
            item-title="name"
            item-value="id"
            @selected="selectPreview"
            @removeItem="removeItem"
          />
        </div>
        <!-- </v-col>
      <v-col cols="2"> -->
        <button
          class="addSample"
          v-if="showSample"
          @click="addSample()"
        >
          {{ selectedPreview ? "Update" : "Add" }} Sample
        </button>
        <button class="addSample" @click="cancel">
          Cancel
        </button>
      </v-col>
    </v-row>

    <!-- <v-card flat class="pa-4"> -->

    <div
      class="wrapper-form pa-7 my-3"
      v-if="
        formBuilderData &&
          formBuilderData.sections &&
          formBuilderData.sections.length > 0
      "
    >
      <FormBuilder
        :key="dynamicFormKey"
        :formBuilder="formBuilderData"
        :showEdit="optionEdit"
        @change-field="changeField"
        @formChanged="formChanged"
        @formSubmitted="formSubmitted"
        :data="freeFormData"
        :class="allowEdit ? 'textBackground' : ''"
      />
    </div>

    <AddDetails
      v-if="
        listBuilderData &&
          listBuilderData.sections &&
          listBuilderData.sections.length > 0
      "
      @detailChanged="detailChanged"
      :formBuilder="listBuilderData"
      :data="detailsData"
      :showAdd="allowEdit"
      :key="dynamicFormKey"
      :selectedPreview="selectedPreview"
    />

    <!-- </v-card> -->

    <v-row class="my-4" v-if="!showModel">
      <v-col cols="3"><attachmodel @addModel="addModel"/></v-col>
    </v-row>

    <v-card-actions class="mr-3" v-if="allowEdit">
      <v-row justify="end" class="dialogBottom" v-if="!showReadOnly">
        <v-btn class="save mr-3" @click="formSubmitted('update')">Save</v-btn>
        <v-btn v-if="selectedPreview" class="save " @click="formSubmitted"
          >Save As</v-btn
        >
      </v-row>
    </v-card-actions>
  </v-card>
  <v-dialog persistent v-model="dialog" width="650px">
    <associateDataModel
      @closeDialog="setFalse()"
      @reload="getAssociateDataModel(formId)"
      :formId="formId"
      :viewType="viewType"
      :selectedModels="selectedModels"
    />
  </v-dialog>
  <v-dialog persistent v-model="textDialog" width="650px">
    <ModelName
      :allowEdit="allowEdit"
      :nameRule="nameRule"
      @closeCard="setFalse('modelName')"
      :submit="formSubmitted"
      @modelName="setFormData"
    />
  </v-dialog>
  <v-dialog persistent v-model="storyDialog" width="650px">
    <storyText
      :allowEdit="allowEdit"
      :nameRule="nameRule"
      @closeCard="setFalse('textAreaData')"
      :submit="formSubmitted"
      @textAreaData="setTextStory"
    />
  </v-dialog>
  
  <v-dialog persistent v-model="optionDialog" width="650px">
    <ChangeOption
      :from="'form'"
      @closeCard="optionDialog = false"
      :editData="modelData"
      @reset-field="start()"
    />
  </v-dialog>
  <v-dialog persistent v-model="deleteDailog" width="650px">
    <DeleteConfirmation :deleteFormId="deleteFormId" @confirm-to-approval="startRemove" @close="deleteDailog=false" />
    </v-dialog>
  <v-dialog persistent v-model="changeDialog" width="650px">
    <changeDialog :deleteFormId="deleteFormId" @confirm-to-approval="startRemove" @closeDialog="changeDialog=false" />
    </v-dialog>
</template>

<script>
import { FormBuilder } from "@tiburadev/vue-comp";
import AddDetails from "./AddDetails.vue";
import ModelName from "./ModelName.vue";
import storyText from "./storyText.vue";
import FormAssessmentSampleService from "@/api/service/FormBuilder/FormAssessmentSampleService";
import AssociateDataModelService from "@/api/service/FormBuilder/AssociateDataModelService";
import ListModelDetailService from "@/api/service/ListModelDetail/ListModelDetailService";
import associateDataModel from "./associateDataModel.vue";
import attachmodel from "./attachmodel.vue";
import CustomAutoComplete from "@/components/ui/CustomAutoComplete.vue";
import ChangeOption from "../settings/Technical/Model/ChangeOption.vue";
import DeleteConfirmation from './DeleteConfirmation.vue'
// import AutoComplete from "@/components/ui/AutoComplete.vue";
export default {
  components: {
    attachmodel,
    associateDataModel,
    AddDetails,
    FormBuilder,
    // AutoComplete,
    CustomAutoComplete,
    DeleteConfirmation,
    ModelName,
    storyText,
    ChangeOption
  },
  data() {
    return {
      deleteDailog:false,
      listModelData:[],
      optionDialog:false,
      optionEdit:true,
      dynamicFormKey: 0,
      showSample: false,
      modelData:null,
      showModel: false,
      storyDialog: false,
      selectedPreviewData: [],
      allowEdit: false,
      textDialog: false,
      selectedPreview: null,
      freeFormData: {},
      detailsData: {},
      detailData: {},
      formData: {},
      freeform: [],
      listForm: [],
      changeDialog:false,
      selectedModels: [],
      listBuilderData: {
        title: "Details",
        sections: [],
      },
      formBuilderData: {
        title: "Details",
        width: "",
        closeIcon: false,
        height2: "500",
        withContainer: false,
        layout: "",
        columns: 12,
        sections: [],
      },

      listmodeldetails: [],
      associatemodelData: [],
      viewType: false,
      dialog: false,
      formId: null,
      sampleData: [],
      nameRule: [(value) => !!value || "Name is Required"],
    };
  },
  created() {
    this.start()
  },

  watch: {
    allowEdit(newVal) {
      this.updateFieldDisabledState(newVal);
    },
    freeFormData(newVal) {
      if (newVal) {
        this.dynamicFormKey++;
      }
    },
    selectedPreview(newVal) {      
      this.getDatabyId(newVal);
    },
  },

  methods: {
    start(){
      this.optionDialog = false
      this.formId = this.$route.query.id;
      this.getAssociateDataModel(this.formId);
      this.getSampleData(this.formId);
    },
    changeField(section,column){
      // console.log("sectionnnn ",section,column)
      // console.log("column ",column)
      // console.log("listmodel",this.listModelData)
      let data = this.listModelData.filter(k=>k.id==column.id)
      if(data && data.length>0){
        this.optionDialog = true
        this.modelData = data[0]
      }
    },
    addSample(){
      this.optionEdit = false
      this.allowEdit = !this.allowEdit
      this.showSample = false;
    },
    setTextStory($event) {
      this.formData.question_story = $event;
    },
    setFormData($event) {
      this.formData.name = $event;
    },
    cancel() {
      if(!this.showSample){
          this.allowEdit = false
          this.start()
      }
      else{
        this.$router.push(`/setting/hr/formBuilder`);
      }
    },
    addModel() {
      this.dialog = true;
    },
    selectPreview(data) {
      this.optionEdit = false
      console.log(data, "gdhddd");
      this.selectedPreview = data;
    },
    async startRemove(){
      let data = {
        id: this.deleteFormId,
        active: 0,
      };
      await FormAssessmentSampleService.update(data);        
      this.getAssociateDataModel(this.formId);
      this.getSampleData(this.formId);
      this.deleteDailog = false

    },
    async removeItem(id) {
      this.deleteFormId = id
      this.deleteDailog = true
    },
    async getSampleData(formID) {
      let res = await FormAssessmentSampleService.findAll({
        form_id: formID,
        active:1
      });
      this.sampleData = res;
    },
    async getDatabyId(id) {
      if (!id) return;

      let res = await FormAssessmentSampleService.findAll({ id: id });
      res = res[0];

      this.formData = res;

      let sampleData = res.sample_data;
      sampleData = JSON.parse(sampleData);
      this.freeFormData = sampleData.header;
      this.detailsData = sampleData.detail;
    },
    async getAssociateDataModel(formID) {
      if (!formID) return;

      let $res = await AssociateDataModelService.findAll({
        form_id: formID,
      });
      if ($res && $res.length > 1) {
        this.showSample = true;
        this.showModel = true
      }

      let res = await Promise.all(
        $res.map(async (element) => {
          let detailData = await ListModelDetailService.findListField(
            { model_id: element.list_model_id }
          );
          this.listModelData = this.listModelData.concat(JSON.parse(JSON.stringify(detailData)))
          element.list_model_details = JSON.parse(JSON.stringify(detailData))
          return element;
        })
      );
      console.log($res,"$res print")
      console.log(res,"res print")
      if (!res || res.length === 0) return;

      this.selectedModels = res.map((item) => item.list_model_id);

      const getFormFields = async (items) => {
        return Promise.all(
          items
            .filter((item) => item.field_type !== null)
            .map(async (item) => ({
              id:item.id,
              multiple: item.multi_select,
              value: item.value,
              text: item.text,
              column_name: item.column_name,
              label: item.label,
              required: item.column_required === 1,
              duplicate: true,
              options: item.options,
              field_type: item.field_type,
              maxLength: item.maxLength || null,
              minLength: item.minLength || null,
              cols: item.width,
              disabled: true,
            }))
        );
      };

      const freeformItems = res.filter(
        (el) => el.form_display_type === "freeform"
      );
      const masterDetailItems = res.filter(
        (el) => el.form_display_type === "masterdetail"
      );
      
      // console.log(this.formBuilderData.sections,"form builder ##")
      // console.log(this.listBuilderData.sections,"listBuilderData builder ##")
      this.formBuilderData.sections = [];
      this.listBuilderData.sections = [];
      for (let freeform of freeformItems) {
        const formFields = await getFormFields(
          freeform.list_model_details || []
        );
        this.formBuilderData.list_model_id = freeform.list_model_id
        this.formBuilderData.sections.push({ columns: formFields });
      }

      let i = 0;
      for (let listForm of masterDetailItems) {
        const detailsField = await getFormFields(
          listForm.list_model_details || []
        );
        this.listBuilderData.list_model_id = listForm.list_model_id
        this.listBuilderData.sections.push({
          title: `masterdetail ${i++}`,
          columns: detailsField,
        });
        this.dynamicFormKey++;
      }
      console.log
      console.log(this.formBuilderData,"hello formBuilderData")
    },

    updateFieldDisabledState(allowEdit) {
      this.formBuilderData.sections.forEach((section) => {
        section.columns.forEach((field) => {
          field.disabled = !allowEdit;
        });
      });
      this.listBuilderData.sections.forEach((section) => {
        section.columns.forEach((field) => {
          field.disabled = !allowEdit;
        });
      });
    },

    setFalse(event) {
      if (event == "modelName") {
        this.textDialog = false;
      } else if (event == "textAreaData") {
        this.storyDialog = false;
      } else {
        this.dialog = false;
      }
    },
    detailChanged($data) {
      this.detailData = $data;
      console.log($data,"detailChangeddetailChanged");
    },
    formChanged($data) {
      this.freeFormData = $data;
      console.log($data,"formChangedformChanged");
    },
    async formSubmitted(type) {
      if (!Object.hasOwn(this.formData, "name")) {
        this.textDialog = true;
      } else {
        if (!Object.hasOwn(this.formData, "question_story")) {
          this.storyDialog = true;
        } else {
          this.detailsData = this.detailData;
          let $data = { header: this.freeFormData,h_ls_id:this.formBuilderData.list_model_id, detail: this.detailsData,d_lm_id:this.listBuilderData.list_model_id };
          $data = JSON.stringify($data);
          this.formData.form_id = this.formId;
          this.formData.sample_data = $data;
          let res;
          if (type == "update" && this.formData.id) {
            this.formData.id = this.selectedPreview;
            res = await FormAssessmentSampleService.update(this.formData);
          } else {
            if (this.formData.id) {
              delete this.formData.id;
            }
            res = await FormAssessmentSampleService.create(this.formData);
            window.location.reload();
          }
          console.log(res);
        }

        // this.formBuilderData.sections = null;
        // this.detailsData = [];
        // this.freeFormData = {};

        // await this.getAssociateDataModel(this.formId);
        // this.formBuilderData.sections = null;
        // this.detailsData = null
        // this.$router.push({ path: "/formBuilder", query: { id: this.formId } });
        // window.location.reload();
      }
    },
  },
};
</script>

<style scoped>
.addSample {
  font-size: 14px;
  font-weight: 500;
  color: #1258ab;
  border: 2px solid #1258ab;
  border-radius: 6px;
  padding: 8px 12px;
  margin-left: 1rem;
  height: fit-content;
  width: fit-content;
}
.textBackground {
  background: #fff;
  padding: 6px;
  border: 1px solid lightgrey;
  border-radius: 4px;
}
</style>
